import { tickerItems } from "../../../mocks/homeData";

export default function UpdateStrip() {
  const doubled = [...tickerItems, ...tickerItems];
  return (
    <section
      id="top"
      className="relative mx-auto mt-16 md:mt-[68px] flex w-full max-w-[1800px] flex-col lg:flex-row items-stretch overflow-hidden rounded-none border-b border-primary-900/20 bg-gradient-to-r from-primary-600 via-primary-500 to-accent-600"
      aria-label="最新动态更新条"
    >
      <div className="flex shrink-0 items-center gap-3 px-4 md:px-6 py-3 text-background-50 lg:border-r lg:border-background-50/20">
        <span className="relative flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-300 opacity-75"></span>
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-background-50"></span>
        </span>
        <span className="text-sm font-bold whitespace-nowrap tracking-wide">92爆料 · 更新条</span>
      </div>

      <div className="relative flex-1 overflow-hidden">
        <div className="ticker-track items-center gap-0 py-3">
          {doubled.map((t, i) => (
            <span
              key={i}
              className="inline-flex shrink-0 items-center gap-3 px-8 text-sm text-background-50/90 whitespace-nowrap"
            >
              <i className="ri-sparkling-2-line text-accent-200 text-sm"></i>
              {t}
            </span>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-primary-500/70 to-transparent"></div>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-primary-500/70 to-transparent"></div>
      </div>

      <div className="flex shrink-0 items-center gap-2 px-4 py-3 md:px-6">
        <a
          href="#entrance"
          className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-4 py-1.5 text-sm font-semibold text-primary-700 hover:bg-accent-100 transition-colors cursor-pointer"
        >
          <i className="ri-send-plane-fill text-sm"></i>
          快速投稿入口
        </a>
      </div>
    </section>
  );
}